import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-rate@2.4.0@rc-rate/es/index.js
// module id = 685
// module chunks = 0